import { render } from "./Bottom.vue?vue&type=template&id=46ddeb96&scoped=true"
import script from "./Bottom.vue?vue&type=script&lang=ts"
export * from "./Bottom.vue?vue&type=script&lang=ts"

import "./Bottom.vue?vue&type=style&index=0&id=46ddeb96&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-46ddeb96"

export default script